// CHANGE BELOW TO SMALL FRIST SMALL CAPS //

import {
  acaraViolet,

  lightVioletSemiTransparent,

} from 'styleVariables/colors';





export const mainNavNotifications = {
  display: 'inline-block',
  position: 'relative',
  iconSize: '2rem',
  width: '2rem',
  height: '2rem',
  float: 'left',
  background: 'transparent',
  borderRadius: '1.6rem',
  backgroundHover: '#ecf1fe'
};

export const toolIconList = {
  display: 'inline-block',
  position: 'relative',
  iconSize: '2rem',
  width: '2rem',
  height: '2rem',
  margin: '1.25rem',
  float: 'right',
  background: lightVioletSemiTransparent,
  iconStroke: acaraViolet,
  borderRadius: '1.6rem',
  hoverIconStroke: acaraViolet,
  backgroundHover: '#ffffff'
};

export const smallSettingsIcon = {
  display: 'inline-block',
  position: 'relative',
  iconSize: '1.2rem',
  width: '2rem',
  height: '2rem',
  padding: '0.4rem',
  margin: '1.25rem',
  float: 'right',
  background: lightVioletSemiTransparent,
  iconStroke: acaraViolet,
  borderRadius: '1.6rem',
  hoverIconStroke: acaraViolet,
  backgroundHover: '#ffffff'
};

export const toolbarEditorTopNavIcon = {
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  iconSize: '1.6rem',
  width: 'fit-content',
  height: '4.5rem',
  padding: '1rem',
  margin: '0',
  float: 'left',
  background: '#ffffff',
  iconStroke: acaraViolet,
  borderRadius: '.6rem',
  hoverIconStroke: acaraViolet,

};

export const toolbarEditorViewPortIcon = {
  display: 'inline-block',
  position: 'relative',
  iconSize: '1.6rem',
  width: 'fit-content',
  height: '4.5rem',
  padding: '1.45rem 1rem',
  margin: '0',
  float: 'left',
  background: 'transparent',
  iconStroke: '#626a92',
  borderRadius: '1.6rem'
};

export const toolbarEditorViewPortIconActive = {
  display: 'inline-block',
  position: 'relative',
  iconSize: '1.6rem',
  width: 'fit-content',
  height: '4.5rem',
  padding: '1.45rem',
  margin: '0',
  float: 'left',
  background: '#333951',
  iconStroke: '#ffffff',
  borderRadius: '1.6rem',
  hoverIconStroke: acaraViolet,
  backgroundHover: '#ffffff'
};

export const illustrateIconDragDrop = {
  display: 'inline-block',
  position: 'relative',
  iconSize: '1.6rem',
  width: '2rem',
  height: '2rem',
  padding: '0.4rem',
  margin: '0',
  float: 'left',
  iconStroke: 'rgb(224, 231, 252)'
};

export const endUserGoBack = {
  display: 'inline-block',
  position: 'relative',
  width: '4rem',
  height: '4rem',
  iconSize: '1.2rem',
  padding: '1.4rem',
  margin: '0',
  background: 'rgba(72, 53, 198, 1)19',
  iconStroke: acaraViolet,
  borderRadius: '2rem',
  transform: 'rotate(180deg)'
};

export const listHeaderControls = {
  display: 'inline-block',
  position: 'relative',
  iconSize: '1.6rem',
  width: '4.5rem',
  height: '4.5rem',
  padding: '1.45rem',
  margin: '1.25rem',
  float: 'right',
  background: lightVioletSemiTransparent,
  iconStroke: acaraViolet,
  iconFill: 'transparent',
  borderRadius: '0.6rem',
  hoverIconStroke: '#ffffff',
  backgroundHover: 'rgba(111, 88, 255, 0.3)'
};

export const listsIcon = {
  display: 'inline-block',
  position: 'relative',
  iconSize: '1.2rem',
  padding: '1rem',
  margin: '0',
  float: 'right',
  background: lightVioletSemiTransparent,
  borderRadius: '0.6rem',
  iconStroke: acaraViolet,
  hoverIconStroke: acaraViolet,
  backgroundHover: '#ffffff'
};

export const listAddOrRemove = {
  ...listsIcon,
  iconStroke: '#FF6256',
  hoverIconStroke: '#ffffff',
  border: '1px solid #FF6256',
  background: '#ffffff',
  backgroundHover: '#FF6256',
  height: '2rem',
  width: '2rem'
};

export const paginationArrows = {
  display: 'inline-block',
  position: 'relative',
  iconSize: '1.2rem',
  margin: '0',
  iconStroke: '#7d7d8f',
  hoverIconStroke: '#7d7d8f'
};

export const smallArrow = {
  display: 'inline-block',
  position: 'relative',
  iconSize: '1.2rem',
  width: '2rem',
  height: '2rem',
  margin: '0',
  iconStroke: acaraViolet,
  hoverIconStroke: acaraViolet,
};

export const sortIcon = {
  display: 'inline-block',
  position: 'relative',
  iconSize: '1.5rem',
  width: '2rem',
  height: '2rem',
  padding: '0.25rem',
  margin: '0',
  background: '#ffffff',
  borderRadius: '0.6rem',
  iconStroke: acaraViolet,
  hoverIconStroke: acaraViolet,
  backgroundHover: lightVioletSemiTransparent
};

export const sortIconActive = {
  ...sortIcon,
  background: lightVioletSemiTransparent,
  backgroundHover: '#ffffff'
};

export const integrationIcon = {
  display: 'inline-block',
  position: 'relative',
  iconSize: '4rem',
  width: '6rem',
  height: '6rem',
  padding: '1rem',
  margin: '0',
  cursor: 'default',
  background: '#FFFFFF',
  borderRadius: '1rem',
  boxShadow: '0 0 4px 0 rgba(145, 150, 178, 0.2)'
};

export const editorBackButtonIcon = {
  iconStroke: acaraViolet,
  transform: 'rotate(180deg)',
  float: 'left'
};

export const iconHideStyles = {
  iconStroke: 'rgb(198, 202, 219)'
};

export const iconShowStyles = {
  iconStroke: 'rgba(111, 88, 255, 1)'
};

export const socialIcons = {
  iconSize: '2rem',
  iconFill: '#5F5D6D',
  hoverIconFill: acaraViolet,
  margin: '0 2rem 0 0',
  width: 'unset'
};

export const stylingButtonIcon = {
  hoverIconStroke: 'rgba(111, 88, 255, 1)', 
  iconFill: 'none', 
}

export const stylingButtonMonospace = {
  hoverIconStroke: 'none',
  hoverIconFill: 'rgba(111, 88, 255, 1)', 
}